module.exports = __webpack_public_path__ + "static/media/terminal_300.0e72923c.png";